var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main",style:({ backgroundColor: _vm.bgColor })},[(_vm.loading)?_c('Loading'):_vm._e(),_vm._v(" "),_c('nuxt',{attrs:{"keep-alive":"","keep-alive-props":{ exclude: [_vm.ComponentNameMap.VideoDetail, _vm.ComponentNameMap.DiscoverSearch] }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }